import { clsx } from 'clsx';
import type { ReactNode } from 'react';
import styles from './ui.module.css';

/**
 * Крупное имя: досье персонажа, карточка внешки.
 *
 * Не вкуишный Title: тот не переносит длинное слово, а имя одним словом
 * упирается в край карточки с overflow: hidden и молча обрезается. Разряд тут
 * умеренный — это данные, а не заголовок экрана.
 *
 * `tone="pink"` — не украшение: так набран номер страницы на экране гостя.
 * Это единственное, что он должен переслать администратору, и малиновым
 * помечено ровно оно.
 */
export function Heading({
  children,
  tone = 'default',
}: {
  children: ReactNode;
  tone?: 'default' | 'pink';
}) {
  return (
    <h2 className={clsx(styles.heading, tone === 'pink' && styles.headingPink)}>{children}</h2>
  );
}
